var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFilledSessionCourse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Live area 20x20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.975 10.9719C11.1647 10.9719 12.3058 10.4993 13.147 9.65797C13.9883 8.8167 14.4609 7.67568 14.4609 6.48594C14.4609 5.29619 13.9883 4.15518 13.147 3.3139C12.3058 2.47262 11.1647 2 9.975 2C8.78526 2 7.64424 2.47262 6.80296 3.3139C5.96169 4.15518 5.48906 5.29619 5.48906 6.48594C5.48906 7.67568 5.96169 8.8167 6.80296 9.65797C7.64424 10.4993 8.78526 10.9719 9.975 10.9719ZM7.02487 11.9688C4.2492 11.9688 2 14.2179 2 16.9936C2 17.5232 2.4299 17.95 2.95638 17.95H16.9936C17.5232 17.95 17.95 17.5201 17.95 16.9936C17.95 14.2179 15.7008 11.9688 12.9251 11.9688H7.02487Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilledSessionCourse);
export default __webpack_public_path__ + "static/media/icon-filled-session-course.d6cad195946f6449c11ad20c7b8c8ef0.svg";
export { ForwardRef as ReactComponent };